function HeaderSection({ title, isLast }) {
    return (
        <div className={`w-[180px] h-[94px] shrink-0 px-6 py-3 flex flex-col ${!isLast && 'border-r border-[#EAEAEA]'}`}>
            <div className="h-1/2 w-full text-center">
                <p className="text-center text-nowrap">{title}</p>
            </div>

            <div className="h-1/2 w-full p-[10px] flex items-center justify-between text-[12px] leading-[10px]">
                <p>cm</p>

                <div className="h-[18px] w-[1px] mr-2 bg-[#EAEAEA]"></div>

                <p>in</p>
            </div>
        </div>
    )
}

export default HeaderSection;
